import React, { Component } from 'react';

import ApiUrls from '../../services/apiUrls';
import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import { KuposErrorSuccessModal } from '.';
import { Link } from 'react-router-dom';
import { NewsLetterSuccessModal } from './NewsLetterSuccessModal';
import PropTypes from 'prop-types';
import i18next from 'i18next';

const footerLeftArr = [
  {
    label: 'FOOTER.CONTACT_NO_NEW',
    value: ' +56 2 3304 8632',
    image: '/images/footer/footer-contact-center.svg',
  },
  {
    image: '/images/footer/footer-email.svg',
    subItems: [
      // {
      //   label: 'FOOTER.EMAIL_ONE',
      //   value: ' viajes@pullman.cl',
      // },
      {
        label: 'FOOTER.EMAIL_TWO',
        value: ' clientes@pullmanbus.cl',
      },
    ],
  },
  {
    label: 'FOOTER.MAIN_OFFICE',
    value: ' San Borja 235, Estación Central - Santiago.',
    image: '/images/footer/footer-location.svg',
  },
];

const footerMiddleArr = [
  // {
  //   name: 'FOOTER.PULLMAN_GO',
  //   internalLink: false,
  //   link: 'https://www.pullmango.cl/',
  // },
  // {
  //   name: 'FOOTER.TANDEM',
  //   internalLink: false,
  //   link: 'https://www.tandemindustrial.cl/',
  // },
  {
    name: 'FOOTER.KNOW_YOUR_RIGHTS',
    internalLink: true,
    link: '/pages/know-your-rights',
  },
  {
    name: 'FOOTER.PRIVACY_POLICIES',
    internalLink: true,
    link: '/pages/privacy-policy',
  },
  {
    name: 'FOOTER.TERMS_AND_CONDITIONS',
    internalLink: true,
    link: '/pages/tnc',
  },
];

const footerRightArr = [
  {
    link: 'https://www.facebook.com/pullman.cl/',
    image: '/images/footer/footer-socialmedia-facebook.svg',
  },
  {
    link: 'https://www.instagram.com/pullmanbus',
    image: '/images/footer/footer-socialmedia-instagram.svg',
  },
  {
    link: 'https://www.linkedin.com/company/pullman-bus/',
    image: '/images/footer/footer-socialmedia-linked-in.svg',
  },
];

export default class KuposFooter extends Component {
  static propTypes = {
    t: PropTypes.func,
    history: PropTypes.object,
    metaData: PropTypes.object,
    actions: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      newsLetterModal: false,
    };
  }

  gotoHome = () => {
    window.scrollTo(0, 0);
    if (CommonService.clearSearchFunction) {
      CommonService.clearSearchFunction();
    }
    this.props.actions.setOnwardPbDate(DateService.getTodayString());
    this.props.actions.setReturnPbDate(null);
    this.props.actions.pbSetSourceCity(null);
    this.props.actions.pbSetDestinationCity(null);
    this.props.actions.setServiceListOnward(null);
    this.props.actions.setServiceListReturn(null);
    if (this.props.history) this.props.history.push('/');
  };

  subscribe = () => {
    if (!this.state.email) {
      this.setState({
        emailError: 'VALIDATIONS.VALID_EMAIL',
      });
      return;
    } else if (!CommonService.isEMailValid(this.state.email)) {
      this.setState({
        emailError: 'VALIDATIONS.VALID_EMAIL_VALIDATION',
      });
      return;
    }
    this.props.actions
      .subscribe({ url: ApiUrls.subscribe(), data: { email: this.state.email } })
      .then(
        res => {
          if (res.data && res.data.status === 200) {
            this.setState({ newsLetterModal: true });
          } else if (res.data) {
            this.setState({
              newsLetterFailureModal: true,
              newsLetterFailureModalMessage: res.data.error,
            });
          }
        },
        err => {},
      );
  };

  render() {
    const { t, history } = this.props;
    const currentYear = new Date().getFullYear();

    return (
      <div className="kupos-footer-main">
        <div className=" footer-container3">
          <div className=" content-container">
            <div className=" footer3 ">
              <div className="footer-top-background-image"></div>

              <div className="new-container ">
                <div className="new-sub-container">
                  <div className="footer-left">
                    {footerLeftArr.map(item => (
                      <div className="footer-left__item">
                        <img src={item.image} className="col-1__img" alt="" />

                        <div>
                          <span style={{ fontSize: '13px' }}>
                            <span className="bold-text" style={{ fontSize: '13px' }}>
                              {t(item.label)}
                            </span>
                            {item.value}
                          </span>

                          {item.subItems &&
                            item.subItems.map(item => {
                              return (
                                <div className="sub-items" style={{ fontSize: '13px' }}>
                                  <span className="bold-text" style={{ fontSize: '13px' }}>
                                    {t(item.label)}
                                  </span>
                                  {item.value}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="footer-middle">
                    <div className="footer-middle__item">
                      <h1 className="bold " style={{ fontSize: '16px' }}>
                        Pullman Bus
                      </h1>
                      <span className="underline"></span>
                      <ul>
                        {footerMiddleArr.map(item => (
                          <div
                            onClick={() => {
                              if (item.link && item.internalLink) {
                                window.scrollTo(0, 0);
                                history.push(
                                  `/${i18next.language == 'es' ? 'es' : 'en'}${item.link}`,
                                );
                              } else {
                                window.open(item.link);
                              }
                            }}
                            className="footer-middle__list"
                          >
                            {t(item.name)}
                          </div>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="footer-right">
                    <div className="footer-right__item">
                      <img
                        src="/images/header-logo-yellow-arrow.svg"
                        className="pointer"
                        onClick={() => {
                          window.scrollTo(0, 0);
                          history.push(
                            `/${i18next.language}/${
                              i18next.language === 'en' ? 'bus-tickets' : 'pasajes-bus'
                            }`,
                          );
                        }}
                        alt=""
                      />
                      <div className="footer-right__social-media">
                        <ul>
                          <li style={{ fontSize: '13px' }}>{t('HOME.FOLLOW_US')}</li>
                          {footerRightArr.map(item => (
                            <li>
                              <a href={item.link} target="_blank">
                                <img src={item.image} alt="" />
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="last-footer "
          style={{ fontSize: '13px' }}
          onClick={() => window.open('https://kupos.cl/es/pasajes/bus/pullman-bus', '_blank')}
        >
          <span className="copyright-message">
            {i18next.language === 'en'
              ? `Pullman Bus ${currentYear}  -  All rights reserved ©   l Sitemap.`
              : `Pullman Bus ${currentYear}  -  Todos los derechos reservados ©   l Mapa del sitio.`}
            {/* {t('HOME.FOOTER_COPYRIGHT')} */}
          </span>
        </div>

        <NewsLetterSuccessModal
          showModal={this.state.newsLetterModal}
          onHide={() => this.setState({ newsLetterModal: false })}
          t={this.props.t}
        />
        <KuposErrorSuccessModal
          onHide={() => this.setState({ newsLetterFailureModal: false })}
          showModal={this.state.newsLetterFailureModal}
          success={false}
          bodyText={this.state.newsLetterFailureModalMessage}
        />
      </div>
    );

    // return (
    //   <div className="kupos-footer-main">
    //     <div className="kupos-footer">
    //       <div className=" content-container">
    //         <div className="footer-logo" onClick={this.gotoHome}>
    //           <img src="/svgs/kupos-logo2.svg" alt={this.props.t('TRANSLATIONS.KUPOS_LOGO2')} />
    //         </div>

    //         <div className="footer-details">
    //           <div className="individual-footer-details">
    //             <div className="individual-footer-item font10">
    //               <span className="bold-footer-item bold-text font14">{t('HOME.OUR_COMPANY')}</span>
    //               <div
    //                 className="underline"
    //                 onClick={() => history.push(`/${i18next.language}/pages/about`)}
    //               >
    //                 {t('HOME.ABOUT_KUPOS')}
    //               </div>
    //               <div
    //                 className="underline"
    //                 onClick={() => history.push(`/${i18next.language}/pages/partners`)}
    //               >
    //                 {t('HOME.OUR_PARTNERS')}
    //               </div>
    //               <div
    //                 className="underline"
    //                 onClick={() => history.push(`/${i18next.language}/pages/our-investors`)}
    //               >
    //                 {t('HOME.OUR_INVESTORS')}
    //               </div>
    //               <div className="underline">{t('HOME.CARRERS')}</div>
    //               <div
    //                 className="underline"
    //                 onClick={() => history.push(`/${i18next.language}/pages/press`)}
    //               >
    //                 {t('HOME.PRESS')}
    //               </div>
    //               <div
    //                 className="underline"
    //                 onClick={() => history.push(`/${i18next.language}/pages/contact`)}
    //               >
    //                 {t('HOME.CONTACT_US')}{' '}
    //               </div>
    //             </div>

    //             <div className="individual-footer-item font10">
    //               <span className="bold-footer-item bold-text font14">
    //                 {t('HOME.USEFUL_DETAILS')}
    //               </span>

    //               <div
    //                 className="underline"
    //                 // onClick={() => history.push(`https://kupos.zendesk.com/hc/es`)}
    //               >
    //                 <a href="https://kupos.zendesk.com/hc/es">{t('HOME.FAQ')}</a>
    //               </div>
    //               <div
    //                 className="underline"
    //                 onClick={() => history.push(`/${i18next.language}/pages/tnc`)}
    //               >
    //                 {t('HOME.TNC')}{' '}
    //               </div>
    //               <div
    //                 className="underline"
    //                 onClick={() => history.push(`/${i18next.language}/pages/privacy-policy`)}
    //               >
    //                 {t('HOME.PRIVACY_POLICY')}{' '}
    //               </div>
    //               <div
    //                 className="underline"
    //                 onClick={() => history.push(`/${i18next.language}/pages/travel-agency`)}
    //               >
    //                 {t('HOME.TRAVEL_AGENCY')}{' '}
    //               </div>
    //               <div
    //                 className="underline"
    //                 onClick={() => history.push(`/${i18next.language}/site-map`)}
    //               >
    //                 {t('HOME.SITEMAP')}
    //               </div>
    //             </div>

    //             <div className="individual-footer-item subscribe-n-social">
    //               <div className="subscribe-div">
    //                 <span className="bold-footer-item bold-text font14">
    //                   {t('HOME.NEWSLETTER')}
    //                 </span>
    //                 <div className="footer-news-letter-input flex-row font10">
    //                   <input
    //                     className="font10"
    //                     type="email"
    //                     placeholder={t('PASSENGER_DETAILS.EMAIL_ID')}
    //                     value={this.state.email}
    //                     onChange={event =>
    //                       this.setState({ email: event.target.value.trim(), emailError: null })
    //                     }
    //                     onBlur={event => this.setState({ email: event.target.value })}
    //                   />
    //                   <button
    //                     onClick={this.subscribe}
    //                     className="kupos-button no-decoration"
    //                     disabled={this.props.subscribePending ? true : false}
    //                   >
    //                     {this.props.subscribePending ? (
    //                       <div className="loader-cricle"></div>
    //                     ) : (
    //                       <span>{t('HOME.SEND')}</span>
    //                     )}
    //                   </button>
    //                 </div>
    //                 {this.state.emailError ? (
    //                   <div style={{ marginTop: -5 }} className="errorMessageInput font8">
    //                     {t(this.state.emailError)}
    //                   </div>
    //                 ) : null}
    //               </div>

    //               <div className="div-social-media-icons">
    //                 <div className="social-icons-footer">
    //                   <div className="footer-social-image">
    //                     {this.props.metaData ? (
    //                       <a
    //                         href={this.props.metaData.social_media_urls.facebookUrl}
    //                         target="_blank"
    //                       >
    //                         <img
    //                           src="/images/icons/home/icon-facebook.png"
    //                           alt={this.props.t('TRANSLATIONS.FB')}
    //                         />
    //                       </a>
    //                     ) : null}
    //                   </div>
    //                   <div className="footer-social-image">
    //                     {this.props.metaData ? (
    //                       <a href={'https://www.instagram.com/pasajebus/'} target="-blank">
    //                         <img
    //                           src="/images/icons/home/icon-instagram.png"
    //                           alt={this.props.t('TRANSLATIONS.INSTA')}
    //                         />
    //                       </a>
    //                     ) : null}
    //                   </div>
    //                   <div className="footer-social-image">
    //                     {this.props.metaData ? (
    //                       <a
    //                         href={this.props.metaData.social_media_urls.twitterUrl}
    //                         target="_blank"
    //                       >
    //                         <img
    //                           src="/images/icons/home/icon-twitter.png"
    //                           alt={this.props.t('TRANSLATIONS.TWITTER')}
    //                         />
    //                       </a>
    //                     ) : null}
    //                   </div>
    //                   <div className="footer-social-image">
    //                     {this.props.metaData ? (
    //                       <a href={this.props.metaData.social_media_urls.blogUrl} target="_blank">
    //                         <img
    //                           src="/images/icons/home/icon-blog.png"
    //                           alt={this.props.t('TRANSLATIONS.BLOG')}
    //                         />
    //                       </a>
    //                     ) : null}
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>

    //     <div className="last-footer font10">
    //       <span className="copyright-message">{t('HOME.FOOTER_COPYRIGHT')}</span>
    //     </div>

    //     <NewsLetterSuccessModal
    //       showModal={this.state.newsLetterModal}
    //       onHide={() => this.setState({ newsLetterModal: false })}
    //       t={this.props.t}
    //     />
    //     <KuposErrorSuccessModal
    //       onHide={() => this.setState({ newsLetterFailureModal: false })}
    //       showModal={this.state.newsLetterFailureModal}
    //       success={false}
    //       bodyText={this.state.newsLetterFailureModalMessage}
    //     />
    //   </div>
    // );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/KuposFooter.js